import { render, staticRenderFns } from "./TaskTypeApprovalProcess.vue?vue&type=template&id=1839f790&scoped=true"
import script from "./TaskTypeApprovalProcess.vue?vue&type=script&lang=js"
export * from "./TaskTypeApprovalProcess.vue?vue&type=script&lang=js"
import style0 from "./TaskTypeApprovalProcess.vue?vue&type=style&index=0&id=1839f790&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839f790",
  null
  
)

export default component.exports